/* eslint-disable prettier/prettier */
import { useState } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

// Componentes de reportes
import DashboardGeneral from "./components/DashboardGeneral";
import ReportesFinancieros from "./components/ReportesFinancieros";
import ReportesOperativos from "./components/ReportesOperativos";
import AnalisisComparativo from "./components/AnalisisComparativo";
import IndicadoresGestion from "./components/IndicadoresGestion";
import ReportesPersonalizados from "./components/ReportesPersonalizados";

import { useMaterialUIController } from "context";

export default function Reportes() {
  const [controller] = useMaterialUIController();
  const { sidenavColor } = controller;
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const renderContent = () => {
    switch (tabValue) {
      case 0:
        return <DashboardGeneral />;
      case 1:
        return <ReportesFinancieros />;
      case 2:
        return <ReportesOperativos />;
      case 3:
        return <AnalisisComparativo />;
      case 4:
        return <IndicadoresGestion />;
      case 5:
        return <ReportesPersonalizados />;
      default:
        return <DashboardGeneral />;
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Card>
              <MDBox p={2}>
                <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                  <MDTypography variant="h5" fontWeight="medium">
                    Reportes y Análisis
                  </MDTypography>
                  <MDBox display="flex" alignItems="center" gap={1}>
                    <Icon fontSize="small">info</Icon>
                    <MDTypography variant="caption" color="text">
                      Dashboard ejecutivo multiempresa
                    </MDTypography>
                  </MDBox>
                </MDBox>
                <Tabs value={tabValue} onChange={handleTabChange}>
                  <Tab
                    label={
                      <MDBox display="flex" alignItems="center" gap={1}>
                        <Icon>dashboard</Icon>Dashboard General
                      </MDBox>
                    }
                  />
                  <Tab
                    label={
                      <MDBox display="flex" alignItems="center" gap={1}>
                        <Icon>account_balance</Icon>Financieros
                      </MDBox>
                    }
                  />
                  <Tab
                    label={
                      <MDBox display="flex" alignItems="center" gap={1}>
                        <Icon>analytics</Icon>Operativos
                      </MDBox>
                    }
                  />
                  <Tab
                    label={
                      <MDBox display="flex" alignItems="center" gap={1}>
                        <Icon>compare</Icon>Comparativos
                      </MDBox>
                    }
                  />
                  <Tab
                    label={
                      <MDBox display="flex" alignItems="center" gap={1}>
                        <Icon>speed</Icon>Indicadores
                      </MDBox>
                    }
                  />
                  <Tab
                    label={
                      <MDBox display="flex" alignItems="center" gap={1}>
                        <Icon>build</Icon>Personalizados
                      </MDBox>
                    }
                  />
                </Tabs>
              </MDBox>
            </Card>
          </Grid>
          <Grid item xs={12}>
            {renderContent()}
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}
